import React from 'react'

const NotFound = () =>{
    console.log(window.location);
    return  <div><h1>Page Not Found</h1></div>
}

export default NotFound;

